// styles.js
const styles = {
  card: {
    marginBottom: 25,
    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
    borderRadius: 20,
  },
  buttonRow: {
    alignContent: "center",
  },
  backButton: {
    marginTop: "auto",
    marginBottom: "auto",
  },
  backButtonText: {
    marginTop: "auto",
    marginBottom: "auto",
    fontSize: 15,
  },
  mainLayout: {
    // Add your MainLayout styles here
  },
  floatButtonGroup: {
    right: 20,
    bottom: "30%",
  },
  floatButtonComp: {
    // Add your FloatButtonComp styles here
  },

  ofInputField: {
    padding: 10,
    borderRadius: 10,
    width: "100%",
  },
  ofInputFieldNumber: {
    width: "100%",
  },
  ofPrimaryBtnColor: {
    backgroundColor: "#15CCAE",
  },
  cardWrapper: {
    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
    borderRadius: 20,
  },
  cardSteps: {
    width: "22%",
    boxShadow: "0px 0px 20px 1px rgba(0,0,0,0.1)",
    borderRadius: 20,
    top: "0",
    height: 600,
  },
  cardStepDisplay: {
    marginLeft: "auto",
    width: "75%",
    boxShadow: "0px 0px 20px 1px rgba(0,0,0,0.1)",
    borderRadius: 20,
    height: 600,
    overflowY: "auto",
  },

  cardWithCustomHeight: {
    marginLeft: "auto",
    boxShadow: "0px 0px 20px 1px rgba(0,0,0,0.1)",
    borderRadius: 20,
    height: 600,
    overflowY: "auto",
  },

  iconSize12: {
    fontSize: 12,
    padding: 3,
    borderRadius: 50,
    color: "var(--of-whithe)",
    backgroundColor: "var(--of-purple)",
  },

  globalPopupWidth: {},
};

export default styles;
